import React, { useState } from 'react';
import { Camera, Music, Dog, Users, Heart, Smile, MessageCircle } from 'lucide-react';

const Pictures = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { name: 'All Photos', icon: Camera, blurb: 'Everything together', value: 'all' },
    { name: 'Concert Life', icon: Music, blurb: 'Nights worth remembering', value: 'concerts' },
    { name: 'Dog Dad', icon: Dog, blurb: 'Sydney and Scout', value: 'dogs' },
    { name: 'Friends', icon: Users, blurb: 'People who make life more fun', value: 'friends' },
    { name: 'Family', icon: Heart, blurb: 'A big part of who I am', value: 'family' },
    { name: 'Lifestyle', icon: Camera, blurb: 'Regular life and random good moments', value: 'lifestyle' }
  ];

  const imagesByCategory = {
    concerts: [
      { url: '/gallery/17988551890621239.webp', caption: 'Worth the late night' },
      { url: '/gallery/18001778032724868.heic.jpg', caption: 'This was a good one' },
      { url: '/gallery/18023608912507605.heic.jpg', caption: 'Live music never gets old' },
      { url: '/gallery/18364072099039110.heic.jpg', caption: 'My kind of night' },
      { url: '/gallery/Screenshot 2023-05-16 200829.jpg', caption: 'Glad I made it to this one' },
      { url: '/gallery/17868275675572185.jpg', caption: 'Good show, better memory' },
      { url: '/gallery/17903850026654626.webp', caption: 'One of those nights you remember' },
      { url: '/gallery/242148432_10202651042490439_8756115109215650432_n.jpg', caption: 'This picture probably sounds loud' }
    ],
    dogs: [
      { url: '/gallery/48422494_10200839078472471_7483954743476224_n.jpg', caption: 'Sydney and Scout' },
      { url: '/gallery/17919581156473829.webp', caption: 'The real bosses' },
      { url: '/gallery/17944507633893176.webp', caption: 'Dog dad life' },
      { url: '/gallery/17957824690633498.webp', caption: 'They know they are spoiled' },
      { url: '/gallery/17964654040527492.webp', caption: 'My two favorite troublemakers' }
    ],
    friends: [
      { url: '/gallery/353676933_10203506345872489_864400521769727914_n.jpg', caption: 'Good people' },
      { url: '/gallery/17868275675572185.jpg', caption: 'Solid night' },
      { url: '/gallery/17988551890621239.webp', caption: 'The crew' },
      { url: '/gallery/IMG_3809.jpg', caption: 'Always a good time' },
      { url: '/gallery/342758091_773551017702458_2397248281369317339_n.jpg', caption: 'One of those nights' },
      { url: '/gallery/IMG_4021.jpg', caption: 'Glad this made the camera roll' },
      { url: '/gallery/318153432_10203230785743658_1932561942670780167_n.jpg', caption: 'Hard to beat good company' },
      { url: '/gallery/305295918_10203039678446095_6302729662367724604_n.jpg', caption: 'Laughing at something we probably should not have' },
      { url: '/gallery/183274278_10202468107557180_5758122616599342821_n.jpg', caption: 'This one has a story' },
      { url: '/gallery/17903850026654626.webp', caption: 'Regular night, good memory' }
    ],
    family: [
      { url: '/gallery/242148432_10202651042490439_8756115109215650432_n.jpg', caption: 'My people' },
      { url: '/gallery/18364072099039110.heic.jpg', caption: 'Family time' },
      { url: '/gallery/123_1(37)[1].jpeg', caption: 'Always matters' },
      { url: '/gallery/12193631_3758618597222_1511275775097042735_n.jpg', caption: 'A big part of my life' },
      { url: '/gallery/17869733198720014.webp', caption: 'Glad this one was captured' },
      { url: '/gallery/16473127_4554723379344_1256315812229091696_n.jpg', caption: 'The people who show up' },
      { url: '/gallery/20211026_201002(1).jpg', caption: 'One of my favorite kinds of pictures' },
      { url: '/gallery/74605588_10201382577579609_4075699324229517312_n.jpg', caption: 'Family keeps me grounded' },
      { url: '/gallery/183444780_10202466738402952_6443380338754210214_n.jpg', caption: 'Love these people' },
      { url: '/gallery/17881512005413735.jpg', caption: 'Quality time' },
      { url: '/gallery/17957791918842056.webp', caption: 'A good reminder of what matters' },
      { url: '/gallery/18007422124508365.webp', caption: 'Simple moment, important people' },
      { url: '/gallery/FB_IMG_1609557845766[1].jpg', caption: 'This is the stuff that means something' }
    ],
    lifestyle: [
      { url: '/gallery/1.jpg', caption: 'Just me' },
      { url: '/gallery/17945397304878562.webp', caption: 'Out and about' },
      { url: '/gallery/18168512053162930.jpg', caption: 'Life lately' },
      { url: '/gallery/20220205_184647.jpg', caption: 'Regular day, good memory' },
      { url: '/gallery/20240628_181513.jpg', caption: 'This one feels like me' },
      { url: '/gallery/35530561_10200557938164139_6568863015616118784_n.jpg', caption: 'Nothing fancy, just real life' },
      { url: '/gallery/417523483_10203844554927504_582491775497373882_n.jpg', caption: 'Caught in a good moment' },
      { url: '/gallery/Capture_edited.jpg', caption: 'One for the memory bank' },
      { url: '/gallery/FB_IMG_1605133929722(1).jpg', caption: 'A little snapshot of my world' },
      { url: '/gallery/FB_IMG_1711810999593.jpg', caption: 'This probably needs context' },
      { url: '/gallery/IMG_0081[1].jpg', caption: 'Good day' },
      { url: '/gallery/IMG_2165(1).jpg', caption: 'Another reason to smile' },
      { url: '/gallery/Resized_20171021_141004.jpeg', caption: 'Not staged, just me' },
      { url: '/gallery/Screenshot_20211218-224444_Instagram.jpg', caption: 'Somewhere in Northwest Arkansas' },
      { url: '/gallery/FB_IMG_1609557845766[1].jpg', caption: 'Simple moment, good day' },
      { url: '/gallery/305295918_10203039678446095_6302729662367724604_n.jpg', caption: 'This one has a backstory' },
      { url: '/gallery/123_1(37)[1].jpeg', caption: 'Proof I leave the house' }
    ]
  };

  const allImages = [
    ...imagesByCategory.concerts,
    ...imagesByCategory.dogs,
    ...imagesByCategory.friends,
    ...imagesByCategory.family,
    ...imagesByCategory.lifestyle
  ];

  const displayedImages = selectedCategory === 'all'
    ? allImages
    : imagesByCategory[selectedCategory] || [];

  return (
    <div className="min-h-screen pt-32 pb-20 bg-black">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Picture <span className="text-gray-400">Gallery</span>
          </h1>
          <p className="text-xl text-gray-300 mb-6">
            A few real snapshots from my life.
          </p>
          <p className="text-lg text-gray-400">
            Some are from nights out. Some are with family. Some are with friends. Some are with the
            dogs. Most probably have a story behind them.
          </p>
        </div>

        {/* Intro */}
        <div className="max-w-3xl mx-auto mb-16 text-gray-400 text-lg space-y-4 text-center">
          <p>This page is not here to make my life look perfect.</p>
          <p>
            It is just a collection of moments that show more than a dating app can. The people I
            care about, the places I go, and the kind of memories I like keeping.
          </p>
          <p className="italic">
            Also, yes, some captions are better than others. I&rsquo;m doing my best here.
          </p>
        </div>

        {/* Categories */}
        <div className="max-w-6xl mx-auto mb-16">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {categories.map((category, index) => {
              const Icon = category.icon;
              const isActive = selectedCategory === category.value;
              return (
                <button
                  key={index}
                  data-testid={`category-${category.value}`}
                  onClick={() => setSelectedCategory(category.value)}
                  className={`bg-gradient-to-br ${
                    isActive
                      ? 'from-white/15 to-white/5 border-white'
                      : 'from-gray-800/50 to-gray-900/50 border-gray-700'
                  } backdrop-blur-sm rounded-xl p-6 border hover:border-white/60 transition-all duration-300 hover:scale-105 text-center cursor-pointer`}
                >
                  <div className={`w-12 h-12 ${
                    isActive ? 'bg-white/20' : 'bg-white/10'
                  } rounded-full flex items-center justify-center mx-auto mb-3`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-white font-semibold mb-1">{category.name}</h3>
                  <p className={`${isActive ? 'text-gray-200' : 'text-gray-400'} text-sm`}>{category.blurb}</p>
                </button>
              );
            })}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <p className="text-gray-400">
              Showing <span className="text-white font-semibold">{displayedImages.length}</span> photos
              {selectedCategory !== 'all' && ` in ${categories.find(c => c.value === selectedCategory)?.name}`}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {displayedImages.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl bg-gray-800 aspect-square hover:scale-105 transition-transform duration-300 cursor-pointer"
              >
                <img
                  src={image.url}
                  alt=""
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Closing call-out */}
        <div className="mt-20 max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-white/20 text-center">
            <Smile className="w-12 h-12 text-white mx-auto mb-4" />
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Like what you see?</h2>
            <p className="text-gray-300 text-lg mb-2">These are just snapshots.</p>
            <p className="text-gray-300 text-lg mb-2">
              The best memories are usually the ones you cannot fully explain in a caption.
            </p>
            <p className="text-gray-300 text-lg mb-8">
              If you made it this far and caught yourself smiling, text me.
            </p>
            <a
              href="tel:+14794227742"
              data-testid="pictures-text-me-btn"
              className="inline-flex items-center gap-2 bg-white hover:bg-gray-200 text-black font-semibold px-8 py-4 rounded-lg transition-all duration-300 hover:scale-105"
            >
              <MessageCircle className="w-5 h-5" />
              Text Me
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pictures;
